import { getCategoriesList } from "Adapters/ApiAdapter/categories";
import { getAoiFilters } from "Adapters/ApiAdapter/filters";
import moment from "moment";

export const CATEGORIES_GET = "categories/get";
export const CATEGORIES_FETCH = "categories/fetch";
export const CATEGORIES_SET = "categories/set";
export const CATEGORIES_UPDATE = "categories/update";
export const CATEGORIES_REMOVE = "categories/remove";

export const AOI_GET = "aoi/get";
export const AOI_FETCH = "aoi/fetch";
export const AOI_SET = "aoi/set";

const lifetime = 5;

const state = {
  categories: [],
  categoriesValid: moment().add(lifetime, "m"),
  aoi: [],
  aoiValid: moment().add(lifetime, "m"),
};

const getters = {
  [CATEGORIES_GET]: ({ categories }) => categories,
  [AOI_GET]: ({ aoi }) => aoi,
};

const actions = {
  [CATEGORIES_FETCH]: ({ commit, state }) => {
    const categories = state.categories;
    const isValid = state.categoriesValid > moment();
    return new Promise((resolve) => {
      if (categories.length && isValid) resolve();
      getCategoriesList().then((response) => {
        commit(CATEGORIES_SET, response.data);
        resolve();
      });
    });
  },
  [AOI_FETCH]: ({ commit, state }) => {
    const aoi = state.aoi;
    const isValid = state.aoiValid > moment();
    return new Promise((resolve) => {
      if (aoi.length && isValid) resolve();
      getAoiFilters().then((response) => {
        commit(AOI_SET, response.data);
        resolve();
      });
    });
  },
};

const mutations = {
  [CATEGORIES_SET]: (state, categories) => {
    state.categories = categories;
  },
  [AOI_SET]: (state, aoi) => {
    state.aoi = aoi;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
